import { render } from "./App.vue?vue&type=template&id=35e4811c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../../jenkins_cache/npm/demo.dot-canvas-book-site/b92cafbe7e73ad711bc4da7266c5b5eb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__